import './EstateImage.e07adb86d0abdad0965293dfa1c5221e.css';
export default {"svg":"_svg_1ax23_1"};